import React, { useState } from 'react';
import './ProductStatusFilter.css';
import { FormControlLabel, Checkbox, Button, IconButton, Tooltip, CircularProgress } from '@material-ui/core';
import { useForm } from 'react-hook-form';
import { useHistory } from 'react-router-dom';
import RefreshIcon from '@material-ui/icons/Refresh';

function ProductStatusFilter({ handleFilters, refreshData }) {
    const [productStatusFilter, setProductStatusFilter] = useState({
        Open: false,
        OnHold: false,
        Closed: false
    });
    const { register, handleSubmit } = useForm();
    const history = useHistory();
    const [isRefreshLoading, setIsRefreshLoading] = useState(false);

    const productStatusFilterChange = (e) => {
        setProductStatusFilter({ ...productStatusFilter, [e.target.name]: e.target.checked });
    }

    const handleChangedFilter = (data) => {
        handleFilters(data);
    }

    const handleRefreshBtn = () => {
        setIsRefreshLoading(true);
        refreshData();
        setProductStatusFilter({
            Open: false,
            OnHold: false,
            Closed: false
        });
        setIsRefreshLoading(false);
    }

    return (
        <>
            <form onChange={handleSubmit(handleChangedFilter)}>
                <div className="allProducts__productStatusFilter">
                    {/* <div className="allProducts__productStatusFilterOpen allProducts__productStatusContent">
                        <FormControlLabel className="allProducts__productStatusFilterLabel"
                            control={<Checkbox checked={productStatusFilter.Open} className="allProducts__productStatusFilterCheckbox"
                                onChange={productStatusFilterChange} name="Open" color="primary" />}
                            label="Open" name="productState.open" inputRef={register} />
                    </div> */}
                    {/* <div className="allProducts__productStatusFilterOnHold allProducts__productStatusContent">
                        <FormControlLabel
                            control={<Checkbox checked={productStatusFilter.OnHold} className="allProducts__productStatusFilterCheckbox"
                                onChange={productStatusFilterChange} name="OnHold" color="primary" />}
                            label="On-Hold" name="productState.onhold" inputRef={register} />
                    </div> */}
                    {/* <div className="allProducts__productStatusFilterClosed allProducts__productStatusContent">
                        <FormControlLabel
                            control={<Checkbox checked={productStatusFilter.Closed} className="allProducts__productStatusFilterCheckbox"
                                onChange={productStatusFilterChange} name="Closed" color="primary" />}
                            label="Closed" name="productState.closed" inputRef={register} />
                    </div> */}
                    <div className="allProducts__productStatusContent allProducts__createStatusContent">
                        <Button variant="contained" className="employerIndex__createPostBtn employerIndex__createProduct"
                            onClick={() => history.push('/retailer/create-product')}>Add Products</Button>
                    </div>
                    <div className="allProducts__productStatusContent allProducts__importProduct ml-5">
                        <Button variant="contained" className="employerIndex__createPostBtn"
                            onClick={() => history.push('/retailer/import-product')}>Import From Excel</Button>
                    </div>
                    <div className="allProducts__productStatusContent">
                        <Tooltip title="Refresh with new data" placement="top">
                            <IconButton color="secondary"
                                onClick={handleRefreshBtn}>
                                {isRefreshLoading ? <CircularProgress size={16} /> : <RefreshIcon fontSize='large' />}
                            </IconButton>
                        </Tooltip>
                    </div>
                </div>
            </form>
        </>
    )
}

export default ProductStatusFilter
